var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.chartOptions)?_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.label))]),(_vm.isReady)?_c('apexcharts',{key:_vm.chartKey,attrs:{"width":"500","height":"350","type":"pie","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }